import * as Sentry from '@sentry/vue'
import { FetchError } from 'ofetch'
import getCurrentHost from '~/utils/api-utils'

export interface TnCsResponse {
  body: {
    acceptedLegalEntityTerms: number[]
  }
}

export function useCudaApi() {
  const apiBase = 'api/customer/cuda'

  const getAcceptedTnCs = async (token: string) => {
    try {
      // If we reach this point, it means we got a successful response
      return await $fetch<TnCsResponse>(`${apiBase}/customer/v2/legal/own/terms`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        baseURL: getCurrentHost(),
      })
    }
    catch (error: unknown) {
      if (error instanceof FetchError) {
        if (error.response?.status === 401 || error.response?.status === 403) {
          Sentry.captureMessage(`Authorization error while fetching accepted TnCs: ${error.message}`, 'error')
          return null
        }
      }
      Sentry.captureException(error)
      return null
    }
  }

  const acceptTnCs = async (legalEntityId: number, token: string) => {
    try {
      await $fetch(`${apiBase}/customer/v2/legal/own/terms/${legalEntityId}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        baseURL: getCurrentHost(),
      })

      // If we reach this point, it means we got a 204 (success)
      return true
    }
    catch (error: unknown) {
      if (error instanceof FetchError) {
        if (error.response?.status === 401 || error.response?.status === 403) {
          Sentry.captureMessage(`Authorization error while accepting TnCs: ${error.message}`, 'error')
          return false
        }
      }
      Sentry.captureException(error)
      return false
    }
  }

  return {
    getAcceptedTnCs,
    acceptTnCs,
  }
}
